export * from './login.component';


// WEBPACK FOOTER //
// ./src/app/layout/login/index.ts